import Icons from "@gstyles/styleguide/icons";
import cx from "classnames";
import styles from "./Overview.module.scss";
import SearchControl from "@components/SearchControl";
import getter from "@services/RoomService/getter";
import { usePageContext } from "@providers/PageProvider";

export default function Overview() {
  const { pageData } = usePageContext();
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.description)}>
        {getter.description(pageData)}
      </div>

      <div className={cx(styles.general)}>
        <div className={cx(styles.item)}>
          <Icons
            name={"square-area-outline"}
            color="#FFFFFF"
            className={cx(styles.icon)}
          />
          <div className={cx(styles.text)}>{getter.size(pageData)}</div>
        </div>
        <div className={cx(styles.item)}>
          <Icons
            name={"twin-beds-outline"}
            color="#FFFFFF"
            className={cx(styles.icon)}
          />
          <div className={cx(styles.text)}>{getter.bedInfo(pageData)}</div>
        </div>
        <div className={cx(styles.item)}>
          <Icons
            name={"two-users-outline"}
            color="#FFFFFF"
            className={cx(styles.icon)}
          />
          <div className={cx(styles.text)}>{getter.capacity(pageData)}</div>
        </div>
        {!!getter.location(pageData) && (
          <div className={cx(styles.item)}>
            <Icons
              name={"eye-outline"}
              color="#FFFFFF"
              className={cx(styles.icon)}
            />
            <div className={cx(styles.text)}>{getter.location(pageData)}</div>
          </div>
        )}
      </div>
      <SearchControl type="booking" />
    </div>
  );
}
